import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
    const thumbsEl = document.querySelector('.js-vertical-industries-thumbs-swiper');
    const mainEl = document.querySelector('.js-vertical-industries-main-swiper');
    const blockEl = document.querySelector('.js-section-vertical-industries-block');

    if (!thumbsEl || !mainEl || !blockEl) return;


    blockEl.addEventListener('mousemove', (e) => {

        const centerX = window.innerWidth / 2;
        const centerY = window.innerHeight / 2;

        const offsetX = e.clientX - centerX;
        const offsetY = e.clientY - centerY;

        const factor = 0.03;

        const moveX = offsetX * factor;
        const moveY = offsetY * factor;

        blockEl.style.backgroundPosition = `
      calc(100% + ${moveX}px) 
      calc(50% + ${moveY}px)
    `;
    });



    // Inicjalizacja Swipera dla thumbs
// 1) Funkcja sprawdzająca i ustawiająca klasy na kontenerze
    function checkEdges(swiper) {
        const el = swiper.el; // główny element .swiper

        if (swiper.isBeginning) {
            el.classList.add('swiper-at-beginning');
        } else {
            el.classList.remove('swiper-at-beginning');
        }

        if (swiper.isEnd) {
            el.classList.add('swiper-at-end');
        } else {
            el.classList.remove('swiper-at-end');
        }
    }

// 2) Inicjalizacja Swipera z obsługą zdarzeń
    const thumbsSwiper = new Swiper(thumbsEl, {
        modules: [Navigation],
        slidesPerView: 2.5,
        spaceBetween: 20,
        navigation: {
            nextEl: '.js-vertical-industries-thumbs-swiper .swiper-button-next',
            prevEl: '.js-vertical-industries-thumbs-swiper .swiper-button-prev',
        },
        loop: false,
        breakpoints: {
            992: {
                slidesPerView: 3,
                spaceBetween: 60
            }
        },
        on: {
            init() {
                // wywołanie checkEdges przy inicjalizacji
                checkEdges(this);
            },
            slideChange() {
                // wywołanie checkEdges przy każdej zmianie slajdu
                checkEdges(this);
            }
        }
    });


    // Inicjalizacja głównego Swipera, korzystającego z Thumbs
    const mainSwiper = new Swiper(mainEl, {
        modules: [Navigation, Pagination, Thumbs],
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        navigation: {
            nextEl: '.js-industries-main-swiper .swiper-button-next',
            prevEl: '.js-industries-main-swiper .swiper-button-prev',
        },
        pagination: {
            el: '.js-industries-main-swiper .swiper-pagination',
            clickable: true,
        },
        thumbs: {
            swiper: thumbsSwiper, // to jest klucz do synchronizacji
        },
    });
});
